import { render, staticRenderFns } from "./buildManagement.vue?vue&type=template&id=12a881ab&scoped=true"
import script from "./buildManagement.vue?vue&type=script&lang=js"
export * from "./buildManagement.vue?vue&type=script&lang=js"
import style0 from "./buildManagement.vue?vue&type=style&index=0&id=12a881ab&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12a881ab",
  null
  
)

export default component.exports